import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { ImpersonateApiAdapter, ImpersonateResponse } from '../adapters/ImpersonateApiAdapter';

class ImpersonateService {
    private adapter: ImpersonateApiAdapter;

    constructor() {
        const httpClient = createHttpClient(apiClientWH);
        this.adapter = new ImpersonateApiAdapter(httpClient);
    }

    async startImpersonation(userId: number): Promise<ImpersonateResponse> {
        return this.adapter.startImpersonation(userId);
    }

    async stopImpersonation(impersonationLogId: number): Promise<ImpersonateResponse> {
        return this.adapter.stopImpersonation(impersonationLogId);
    }
}

export const impersonateService = new ImpersonateService();

